import { useState } from 'react';
import { Box, Card } from '@mui/material';
import { Colors } from '../../../../Styles/Colors';
import { renderTitle, ActionButton } from "./SarasCommonComp";
import { withTranslation } from 'react-i18next';
import DocClinicExamENTLeft from '../Others/DocClinicExamENTLeft';

const SarasClinicExamination = ({ Title, ...props }) => {
    const [state, setState] = useState({
        examinePopup: false,
    });

    const updateState = (updates) => {
        setState((prev) => ({ ...prev, ...updates }));
    };

    const isDataSaved = () => {
        updateState({
            examinePopup: false
        })
    }

    return (
        <Card sx={{
            width: "100%", height: "fit-content", padding: "0.3vw",
            marginBottom: "0.5vw", border: `2px solid ${props.isSelected ? Colors.themeDark : Colors.white}`
        }}>
            <Box display={"flex"} flexDirection={'row'} alignItems={"center"} justifyContent={'space-between'} padding={"0.5vw"} borderBottom={`1px solid #E3E2E2`}>
                {renderTitle(Title, props.isSelected)}
                <ActionButton
                    text={"Examine"}
                    emed_tid='doc_notes_bold_clr'
                    disabled={props.isLocked}
                    onClick={() => { updateState({ examinePopup: true }) }}
                />
            </Box>
            <DocClinicExamENTLeft
                appointmentId={props.appointmentId}
                PatientData={props.PatientData}
                isLocked={props.isLocked}
                examinePopup={state.examinePopup}
                isDataSaved={isDataSaved}
                custom_name={Title}
            />
        </Card>
    )
}

export default withTranslation()(SarasClinicExamination)